import { motion } from 'framer-motion';
import { UserTable } from '../../ComponentTypes/UserTable';
import ProductContext from '../../memory/CategoryContext';

class LoadingMiddlewareTable extends UserTable {
  constructor(props: any) {
    super(props);
  }

  public override tBodyComp() {
    return (
      <tbody {...this.props.getTableBodyProps()} className={this.stylingTBodyComp}>
        {this.rows.map((row: any, i: any) => {
          this.prepareRow(row);
          return this.trComp(row, i);
        })}
      </tbody>
    );
  }
}

export default LoadingMiddlewareTable;
